import React from 'react';

const NoopComponent = () => {
  return <span></span>;
};

export default NoopComponent;
